import React, { useMemo } from 'react';
import { Box, Grid, Typography, TypographyProps, Theme } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { buildSectionHeader } from './helper';
import { multilineEllipsis } from '../../theme/styles/mixins';
import { OrganizationColorsSchema } from '../../definitions/schemas';
import OrganizationThemeContextProvider from '../../lib/context/OrganizationThemeContext';
import SectionHeaderLogo from './SectionHeaderLogo';

interface Props {
  className?: string;
  disableAvatar?: boolean;
  icon?: React.ReactNode | string;
  logo?: string;
  name: string;
  orgColors?: OrganizationColorsSchema;
  variant: TypographyProps['variant'];
}

const useStyles = makeStyles((theme: Theme) => ({
  icon: {
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  name: {
    ...multilineEllipsis(3),
  },
}));

const SectionHeader: React.FC<Props> = (props: Props): JSX.Element => {
  const classes = useStyles();

  const { className, disableAvatar, icon, logo, name, orgColors, variant } =
    props;

  const sectionHeader = useMemo(
    () => buildSectionHeader(name, icon as string, logo),
    [icon, logo, name]
  );

  return (
    <Grid alignItems="center" className={className} container>
      {!disableAvatar && (
        <OrganizationThemeContextProvider colors={orgColors}>
          <SectionHeaderLogo
            classes={{ icon: classes.icon, logo: classes.icon }}
            sectionHeader={sectionHeader}
          />
        </OrganizationThemeContextProvider>
      )}
      <Box
        className={classes.name}
        flexBasis={0}
        flexGrow={1}
        pl={disableAvatar ? 0 : 2}
      >
        <Typography color="textPrimary" title={name} variant={variant}>
          {name}
        </Typography>
      </Box>
    </Grid>
  );
};

export default SectionHeader;
